module.exports = __webpack_public_path__ + "img/bg-web.2fad5062.png";